<template>
  <div class="the-navbar__user-meta flex items-center">
    <div
      v-if="userData && userData.firstName"
      class="text-right leading-tight hidden sm:block items-center mr-3"
    >
      <!-- <h6>{{ userData.firstName }} {{ userData.lastName }}</h6> -->
      <!-- <small>Online</small> -->
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img">
        <vs-avatar
          v-if="userData && userData.profilePictureUrl"
          class="m-0"
          size="32px"
          :src="
            constants.s3Bucket +
            '/editor/profile-pictures/' +
            userData.profilePictureUrl
          "
        />
        <vs-avatar
          v-else
          class="m-0"
          size="32px"
          :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
            userData.firstName,
            userData.lastName
          )}`"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 15rem">
          
          

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/organization/create').catch(() => {})"
          >
            <!-- <feather-icon icon="WorkIcon" svgClasses="w-4 h-4" /> -->
            <vs-icon icon="business" size="17px" />
            <span class="ml-2">{{ $t('orgDashboard.userDashboard.profileDropDown.createOrganization') }}</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/user/settings').catch(() => {})"
          >
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t('orgDashboard.userDashboard.profileDropDown.settings') }}</span>
          </li>

          <vs-divider class="m-1" />

          <!-- START: Language Selector -->
          <li class="flex items-center py-3 px-4 cursor-default border-b border-gray-100 mb-1">
            <feather-icon icon="GlobeIcon" svgClasses="w-4 h-4 text-gray-600" />
            <div class="flex items-center ml-3 space-x-2">
              <!-- EN Button -->
              <div
                @click="changeLanguage('en')"
                class="flex items-center px-2 py-1 rounded cursor-pointer text-xs font-semibold transition-colors"
                :class="$i18n.locale === 'en' ? 'bg-primary text-white' : 'text-gray-500 hover:bg-gray-100'"
              >
                <img src="https://flagcdn.com/w20/us.png" alt="EN" class="w-4 h-3 mr-1" />
                EN
              </div>
              
              <!-- PT Button -->
              <div
                @click="changeLanguage('pt')"
                class="flex items-center px-2 py-1 rounded cursor-pointer text-xs font-semibold transition-colors"
                :class="$i18n.locale === 'pt' ? 'bg-primary text-white' : 'text-gray-500 hover:bg-gray-100'"
              >
                <img src="https://flagcdn.com/w20/pt.png" alt="PT" class="w-4 h-3 mr-1" />
                PT
              </div>
            </div>
          </li>
          <!-- END: Language Selector -->

          <vs-divider class="m-1" />
          
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t('orgDashboard.userDashboard.profileDropDown.logout') }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import constants from "@/constants";

export default {
  data() {
    return {
      constants,
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
  },
  methods: {
    // New Method to handle Language Change
    changeLanguage(locale) {
      this.$i18n.locale = locale;
      // Optional: Save to local storage so the language persists on page refresh
      localStorage.setItem('userLanguage', locale);
    },
    logout() {
      //TalentPaint Session Destroy For Alex
      this.$store.dispatch(
        "alex/deleteSession",
        this.$store.state.auth.user._id
      );
      //TalentPaint Session Destroy For Gala Or Journey App
      this.$store.dispatch(
        "boards/deleteSession",
        this.$store.state.auth.user._id
      );
      //Youlab Session Destroy For Gala Or Journey App
      this.$store.dispatch(
        "editor/deleteSession",
        this.$store.state.auth.user._id
      );
      this.$store.dispatch("auth/logout").then(() => {
        window.location.href = "/";
      });
    },
    configUserDashboard() {
      this.$store.commit("dashboard/SET_CONFIG_DASHBOARD", true);
      document.querySelector(".con-img").click();
    },
  },
};
</script>